import React from 'react';
import MultiImageSection from './MultiImageSection';
import * as FiIcons from 'react-icons/fi';

const { FiX } = FiIcons;

function NewInjusticeSection({ 
  images, 
  onAddImage, 
  onDeleteImage 
}) {
  return (
    <MultiImageSection
      title="Ingiustizie subite"
      description="Carica fino a 5 immagini per visualizzare le ingiustizie che hai subito e ricordarti di lottare per i tuoi obiettivi."
      icon={FiX}
      colorClass="red"
      images={images}
      onAddImage={onAddImage}
      onDeleteImage={onDeleteImage}
      maxImages={5}
    />
  );
}

export default NewInjusticeSection;